
import * as api from '~/api/index';
export default {
  layout: 'protocol',
  async asyncData({ error, route, $axios }) {
    try {
      const name = route.params.page;
      const res = await $axios(api.getDocDetail(name));
      return {
        title: res.result.title,
        content: res.result.content,
      };
    } catch (err) {
      console.warn(err);
      error({
        statusCode: 404,
        message: {
          title: '很抱歉您访问的页面出错了！',
          desc:
            '可能原因：1、系统繁忙；2、网络链接失败；3、找不到请求页面；' +
            `4、asyncData ${err.message}`,
        },
      });
    }
  },
  head() {
    return {
      title: this.title,
    };
  },
};
